export default "__VITE_ASSET__Bx6qVmgO__"